import BlogRubricField from "./BlogRubricField";

export default BlogRubricField;
